export const navbar = {
    listItems: {
        brandMobile: {
            title: "Agustín Galluzzo",
            classes: "m-auto custom-logo-collapse",
            brand: true,
            path: "/admin/menu",
            exact: false,
            img: './assets/images/logo/small/dark.png'
        },
        items: [
            {
                title: "Agustín Galluzzo",
                classes: "ml-2 mr-4 custom-logo",
                brand: true,
                path: "/admin/menu",
                exact: false,
                img: './assets/images/logo/medium/dark.png'
            },
            {
                title: "Inicio",
                classes: "mx-2 custom-border-bottom-navbar-item",
                brand: false,
                path: "/admin/menu",
                exact: true
            },
            {
                title: "Trabajos",
                classes: "mx-2 custom-border-bottom-navbar-item",
                brand: false,
                path: "/admin/menu/trabajos",
                exact: false
            },
            {
                title: "Sobre Mí",
                classes: "mx-2 custom-border-bottom-navbar-item",
                brand: false,
                path: "/admin/menu/sobremi",
                exact: false
            },
            {
                title: "Contacto",
                classes: "mx-2",
                brand: false,
                path: "/admin/menu/contacto",
                exact: true
            }
        ]
    }
};

export const footer =
{
    listItems: [
        {
            title: "Mis trabajos",
            list: [{
                path: "/admin/menu/",
                name: "Inicio"
            }, {
                path: "/admin/menu/trabajos",
                name: "Trabajos"
            }]
        },
        {
            title: "Agustín Galluzzo",
            list: [{
                path: "/admin/menu/sobremi",
                name: "Sobre Mí"
            }, {
                path: "/admin/menu/contacto",
                name: "Contacto"
            }]
        }
    ],
    copyright: "Copyright © " + (new Date()).getFullYear() + " Agustín Galluzzo.",
    developBy: "Diseñado y desarrollado por",
    brand: { text: "ARdevs", href: "/", target: "_blank" }
};

export const routePages = [
    {
        id: 1,
        path: '/admin/menu/',
        cmp: "Inicio",
        exact: true
    },
    {
        id: 2,
        path: '/admin/menu/trabajos',
        cmp: "Trabajos",
        exact: false
    },
    {
        id: 3,
        path: '/admin/menu/sobremi',
        cmp: "Sobre Mí",
        exact: false
    },
    {
        id: 4,
        path: '/admin/menu/contacto',
        cmp: "Contacto",
        exact: false
    },
    {
        id: 5,
        path: '/admin/menu',
        cmp: "Error404",
        exact: false,
        error404: true
    },
];